import { Button } from "primereact/button";
import { Tooltip } from "primereact/tooltip";
import { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import Loading from "../../../../components/Loading/Loading";
import { useToastContext } from "../../../../contexts/ToastContext/ToastContext";
import localeText from "../../../../locale";
import GetUserInfoService from "../../../../service/GetUserInfoService";
import { formatPrice } from "../../../../utilities/formatPrice";
import { CartItem } from "./CartItem";
import SectionProducts from "../../../Shop/components/SectionProducts/SectionProducts";
import useShopSections from "../../../Shop/hooks/useShopSections";
import { useHistory } from "react-router-dom";
import IntegrationService from "../../../../service/IntegrationService";
import { useLocation } from "react-router-dom";

const CartItems = ({
  walletBalance,
  order,
  setOrder,
  isLoadingOrder,
  currencyProduct,
  currencyCodeUser,
  currencyUser,
  setCashback,
  setPage,
  setPrice,
  orderItems,
  setOrderItems,
  walletExtracoinBalance,
  userPercentExtracoin,
  walletExtracoinBalanceForex,
  setOrderIsEmpty,
  orderIsEmpty,
  cashback,
  isLoadingWalletExtracoinBalanceForex,
}) => {
  const location = useLocation();

  const isFringeBenefitsPage = location?.pathname?.toLowerCase()?.includes("fringe");

  const orderCurrency = isFringeBenefitsPage
    ? order?.fringeBenefit?.currency
    : order?.itens?.[0]?.product?.currency;

  const orderKey = isFringeBenefitsPage
    ? "__extraconomy_order_fringe_benefit"
    : "__extraconomy_order";

  const urlToCheckCatalog = isFringeBenefitsPage
    ? "/fringe-benefits?search=ALL&currency=ALL&area=ALL"
    : "/shop";

  const { showErrorToast } = useToastContext();
  const [loading, setLoading] = useState(false);
  const [isLoadingToContinue, setIsLoadingToContinue] = useState(false);

  const getUserInfoService = new GetUserInfoService();
  const userInfoService = new GetUserInfoService();
  const integrationService = new IntegrationService();

  const currencyFormat = {
    USD: "$",
    EUR: "€",
    BRL: "R$",
    GBP: "£",
    JPY: "¥",
    CNY: "¥",
    AUD: "AU$",
    CAD: "CA$",
    CHF: "CHF",
  };

  const toast = useRef(null);

  const { shopSections, isLoading } = useShopSections({
    onError: (code) => showErrorToast(code, toast?.current),
  });

  const history = useHistory();

  async function sendInitiateCheckout() {
    let dataLayer = window.dataLayer || [];
    dataLayer.push({
      event: "InitiateCheckout",
    });
    const user = await getUserInfoService.getUserInfo(
      localStorage.getItem("__extraconomy_token"),
      localStorage.getItem("__extraconomy_username")
    );
    let ip = await integrationService.getUserIp();
    let date = new Date();
    let payload = {
      eventData: {
        currency: "",
        value: 0,
      },
      eventName: "InitiateCheckout",
      eventTime: Math.floor(date.getTime() / 1000),
      userData: {
        email: user.result.user?.email ? user.result.user.email : "",
        ipAddress: ip.data.ip,
        phone: user.result.user?.phoneNumber ? user.result.user.phoneNumber : "",
        userAgent: window.navigator.userAgent,
      },
    };
    let res = await integrationService.sendEvent(payload);
    return res;
  }

  useEffect(() => {
    if (orderItems) {
      setLoading(true);
      let cashbackValue = 0;

      orderItems.forEach((item) => {
        let price;

        if (item?.product.promotionalPriceUnique && !item?.product.productVariation) {
          price = item?.product.promotionalPriceUnique;
        } else {
          price = item?.priceUnitary;
        }

        const cashbackPercent = item?.product?.percentExtraCoin / 100;
        cashbackValue = cashbackValue + price * cashbackPercent * item.quantity;
      });

      setCashback(cashbackValue);
      setLoading(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [orderItems]);
  console.log(order);
  const isLoadingAll = !isLoadingWalletExtracoinBalanceForex && !!userPercentExtracoin;

  return (
    <div className="pt-4 pb-8" style={{ minHeight: "70vh" }}>
      {!isLoadingAll && !orderIsEmpty ? (
        <div>
          {/* <div className="flex md:align-items-center align-items-start md:flex-row w-full justify-content-start flex-column gap-2">
            <Link to="/shop">
              <button className="cursor-pointer py-2 px-4 flex w-full gap-2 align-items-center border-none border-round bg-green-500 hover:bg-green-600 text-white">
                <i className="pi pi-arrow-left"></i>
                <p className="font-semibold">{localeText("shop")}</p>
              </button>
            </Link>
            <h2 className="m-0">{localeText("shoppingCart")}</h2>
          </div> */}
          <hr />
          <Loading classNameIcon={"text-4xl"} />
        </div>
      ) : (
        <>
          {order && !orderIsEmpty && (
            <div
              className="font-bold text-xl my-3 flex gap-2 align-items-center justify-content-between"
              style={{ color: "#344563" }}
            >
              {localeText("confirmation")}{" "}
              <Button
                link
                className="p-no-outline flex gap-2 align-items-center"
                style={{ color: "#245AE5" }}
                onClick={() => {
                  history.push("/shop");
                }}
              >
                <i className="pi pi-arrow-left text-xs"></i>{" "}
                <span className="underline">{localeText("backAction")}</span>
              </Button>
            </div>
          )}
          {order && !orderIsEmpty && (
            <div className="grid grid-nogutter gap-4">
              <div
                className="col-12 md:col-8 card h-full p-4 border-round-lg border-none flex flex-column gap-3"
                style={{ boxShadow: "0px 0px 40px  #5F58521A" }}
              >
                <div className="uppercase border font-bold" style={{ color: "#344563" }}>
                  {localeText("productServices")}
                </div>
                <hr className="mt-0 mb-2"></hr>
                {isFringeBenefitsPage ? (
                  <>
                    <CartItem
                      product={order.fringeBenefit}
                      setLoading={setLoading}
                      setOrder={setOrder}
                      setOrderItems={setOrderItems}
                      setOrderIsEmpty={setOrderIsEmpty}
                      order={order}
                    />
                  </>
                ) : (
                  <>
                    {orderItems?.map((product, idx) => (
                      <CartItem
                        product={product}
                        setLoading={setLoading}
                        setOrder={setOrder}
                        setOrderItems={setOrderItems}
                        setOrderIsEmpty={setOrderIsEmpty}
                        key={idx}
                      />
                    ))}
                  </>
                )}
              </div>

              {order && (
                <div className="col-12 md:col flex flex-column gap-2">
                  <div
                    className="card p-4 border-round-lg border-none"
                    style={{ boxShadow: "0px 0px 40px  #5F58521A" }}
                  >
                    <div className="flex justify-content-between align-items-baseline">
                      <div className="font-bold uppercase" style={{ color: "#344563" }}>
                        {localeText("orderResume")}
                      </div>
                      <span className="text-gray-500">
                        {isFringeBenefitsPage ? 1 : orderItems?.length}{" "}
                        {orderItems?.length > 1 ? "items" : "item"}
                      </span>
                    </div>
                    <hr />
                    <div
                      className="flex flex-column gap-2 text-sm font-medium"
                      style={{ color: "#505F79" }}
                    >
                      <div className="flex justify-content-between">
                        <span>{localeText("subtotal")}</span>
                        <span className="font-normal" style={{ color: "#091E42" }}>
                          {currencyFormat[currencyProduct]}{" "}
                          {formatPrice(isFringeBenefitsPage ? order.totalOrder : order.amountOrder)}
                        </span>
                      </div>

                      {!isFringeBenefitsPage && (
                        <div className="flex justify-content-between">
                          <div className="">
                            <span>{localeText("platformFee")}</span>
                            <Tooltip target=".extracoin-tooltip" position="bottom" />
                            <i
                              className="pi pi-info-circle ml-1 extracoin-tooltip cursor-pointer text-600 align-self-start gap-0"
                              data-pr-tooltip={localeText("plataformFeeExplanation")}
                              data-pr-position="right"
                              data-pr-at="right+5 top"
                              data-pr-my="left center-2"
                              tooltipoptions={{ event: "focus" }}
                            />
                          </div>

                          <span className="font-normal" style={{ color: "#091E42" }}>
                            {currencyFormat[currencyProduct]} {formatPrice(order.amountToPlatform)}
                          </span>
                        </div>
                      )}

                      <>
                        <div className="flex flex-column">
                          <hr className="mb-0" />
                          <span
                            className="text-xs font-normal px-2 py-1 w-fit"
                            style={{ color: "#253858", backgroundColor: "#EBECF0" }}
                          >
                            {localeText("yourCredits")}
                          </span>
                        </div>

                        <div className="flex flex-column gap-2 mb-3 mt-2">
                          <div className="flex justify-content-between">
                            <span>{localeText("balanceAvailable")}</span>
                            <span className="font-normal text-right" style={{ color: "#46A748" }}>
                              + {currencyFormat[currencyProduct]}{" "}
                              {formatPrice(
                                parseFloat(walletExtracoinBalance * (userPercentExtracoin / 100))
                              )}
                              {currencyCodeUser !== orderCurrency && (
                                <>
                                  {" "}
                                  (≈ {currencyFormat[currencyProduct]}{" "}
                                  {formatPrice(
                                    parseFloat(
                                      walletExtracoinBalanceForex * (userPercentExtracoin / 100)
                                    )
                                  )}
                                  )
                                </>
                              )}
                            </span>
                          </div>
                          <div className="flex justify-content-between">
                            <span>{localeText("walletBalance")}</span>
                            <span className="font-normal text-right" style={{ color: "#46A748" }}>
                              + {currencyFormat[currencyProduct]} {formatPrice(walletBalance)}
                            </span>
                          </div>
                        </div>
                      </>

                      <hr className="my-2"></hr>
                      <div className="flex justify-content-between">
                        <span>{localeText("total")}</span>
                        <span style={{ color: "#46A748", fontSize: "1rem" }}>
                          <b>
                            {currencyFormat[currencyProduct]}{" "}
                            {formatPrice(
                              isFringeBenefitsPage ? order.totalOrder : order.amountTotal
                            )}
                          </b>
                        </span>
                      </div>
                    </div>

                    {/*  <hr /> */}

                    <div className="text-right my-4">
                      <p className="text-sm font-light" style={{ color: "#7A869A" }}>
                        {localeText("paypalPayment")}
                      </p>
                    </div>

                    {cashback > 0 && (
                      <div className="flex justify-content-center align-items-center gap-2 text-green-500 mb-3">
                        <svg
                          width="14"
                          height="14"
                          viewBox="0 0 14 14"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            fillRule="evenodd"
                            clipRule="evenodd"
                            d="M9.53123 0.761804C9.40167 0.631921 9.19074 0.630294 9.05988 0.760176L7.74217 2.06942L7.70794 2.10927C7.66678 2.16561 7.64386 2.23394 7.64386 2.30477C7.64386 2.39299 7.67837 2.47795 7.74087 2.54078L9.08982 3.89755L9.14213 3.94051C9.19761 3.97736 9.2617 3.99585 9.32615 3.99585C9.41144 3.99585 9.49607 3.96363 9.56118 3.89885C9.69204 3.76897 9.69204 3.55803 9.56248 3.42749L8.78554 2.64624L8.93249 2.65477C10.8328 2.80285 12.3346 4.3925 12.3346 6.33016C12.3346 6.51441 12.4837 6.6635 12.6679 6.6635C12.8522 6.6635 13.0013 6.51441 13.0013 6.33016C13.0013 3.97274 11.1191 2.05148 8.77887 1.97925L9.52993 1.23316L9.56855 1.18718C9.6588 1.05771 9.64697 0.878123 9.53123 0.761804ZM7.33331 4.16683C7.33331 2.23682 5.763 0.666829 3.83331 0.666829C1.90363 0.666829 0.333313 2.23682 0.333313 4.16683C0.333313 6.09684 1.90363 7.66683 3.83331 7.66683C5.763 7.66683 7.33331 6.09684 7.33331 4.16683ZM10.1666 7.00016C12.0963 7.00016 13.6666 8.57015 13.6666 10.5002C13.6666 12.4302 12.0963 14.0002 10.1666 14.0002C8.23696 14.0002 6.66665 12.4302 6.66665 10.5002C6.66665 8.57015 8.23696 7.00016 10.1666 7.00016ZM1.33331 8.00016C1.51756 8.00016 1.66665 8.14925 1.66665 8.3335C1.66665 10.2712 3.16848 11.8608 5.06877 12.0089L5.21572 12.0174L4.43878 11.2362C4.30922 11.1056 4.30922 10.8947 4.44008 10.7648C4.5564 10.6494 4.73548 10.637 4.86529 10.7274L4.91144 10.7661L6.2604 12.1229C6.3229 12.1857 6.3574 12.2707 6.3574 12.3589C6.3574 12.4297 6.33449 12.4981 6.29332 12.5544L6.25909 12.5942L4.94139 13.9035C4.87628 13.9679 4.791 14.0002 4.70636 14.0002C4.62042 14.0002 4.53514 13.9673 4.47003 13.9019C4.35429 13.7855 4.34246 13.6059 4.43271 13.4765L4.47133 13.4305L5.22239 12.6844C2.88218 12.6122 0.99998 10.6909 0.99998 8.3335C0.99998 8.14925 1.14907 8.00016 1.33331 8.00016ZM7.33331 10.5002C7.33331 8.93799 8.60415 7.66683 10.1666 7.66683C11.7291 7.66683 13 8.93799 13 10.5002C13 12.0623 11.7291 13.3335 10.1666 13.3335C8.60415 13.3335 7.33331 12.0623 7.33331 10.5002ZM10.1549 8.12614C10.3187 8.12614 10.4547 8.24394 10.4829 8.39952L10.4883 8.45947V8.71794C10.6539 8.75359 10.8028 8.80546 10.9213 8.85455L11.0481 8.91092L11.1721 8.97453L11.2031 8.99235C11.36 9.0874 11.4101 9.2915 11.3157 9.44873C11.2313 9.58936 11.0603 9.64382 10.9128 9.58903L10.7602 9.51175L10.6511 9.46332C10.5052 9.40363 10.2992 9.33936 10.0892 9.33936C9.82681 9.33936 9.55533 9.45296 9.55533 9.64339C9.55533 9.84281 9.78047 9.97534 10.1404 10.1264L10.5235 10.2807L10.7005 10.3568C11.112 10.5441 11.4967 10.8074 11.4967 11.3075C11.4967 11.7131 11.2556 12.1416 10.6134 12.2803L10.4883 12.3028V12.5409C10.4883 12.7251 10.3392 12.8742 10.1549 12.8742C9.99116 12.8742 9.85517 12.7564 9.82697 12.6008L9.8216 12.5409V12.3031C9.4517 12.2522 9.20328 12.1226 9.06387 12.027L8.98695 11.9695L8.93033 11.9185C8.80207 11.7863 8.80598 11.575 8.93814 11.4471C9.05677 11.3345 9.23611 11.3244 9.36412 11.4163L9.42695 11.4695L9.47678 11.5029C9.57658 11.5632 9.79095 11.6597 10.1439 11.6597C10.4004 11.6597 10.8301 11.6138 10.8301 11.3075C10.8301 11.1754 10.6609 11.0678 10.3972 10.9515L10.2082 10.8722L9.93028 10.7611L9.75257 10.685C9.30904 10.4849 8.88866 10.2013 8.88866 9.64339C8.88866 9.18666 9.22236 8.8326 9.71995 8.71539L9.8216 8.69515V8.45947C9.8216 8.27523 9.97069 8.12614 10.1549 8.12614ZM3.83331 1.3335C2.27081 1.3335 0.99998 2.60466 0.99998 4.16683C0.99998 5.729 2.27081 7.00016 3.83331 7.00016C5.39581 7.00016 6.66665 5.729 6.66665 4.16683C6.66665 2.60466 5.39581 1.3335 3.83331 1.3335ZM4.15753 4.46989C4.34178 4.46989 4.49087 4.61898 4.49087 4.80322C4.49087 4.967 4.37307 5.10299 4.21749 5.13119L4.15753 5.13656H2.93528C3.17067 5.48832 3.50958 5.65771 3.97915 5.65771C4.36652 5.65771 4.55467 5.54541 4.86326 5.30713C5.00779 5.1945 5.21873 5.22054 5.33071 5.36768C5.44334 5.51351 5.41665 5.72282 5.27081 5.83512C4.92316 6.1027 4.58657 6.32438 3.97915 6.32438C3.184 6.32438 2.59189 5.95672 2.24267 5.26246L2.18357 5.13656H1.85805C1.67381 5.13656 1.52472 4.98747 1.52472 4.80322C1.52472 4.63945 1.64252 4.50345 1.7981 4.47526L1.85805 4.46989H4.15753ZM5.27081 2.49854C4.92316 2.23096 4.58657 2.00928 3.97915 2.00928C3.06415 2.00928 2.41494 2.49207 2.0991 3.40413H1.85805L1.7981 3.4095C1.64252 3.4377 1.52472 3.57369 1.52472 3.73747C1.52472 3.92171 1.67381 4.0708 1.85805 4.0708H4.15753L4.21749 4.06544C4.37307 4.03724 4.49087 3.90124 4.49087 3.73747C4.49087 3.55322 4.34178 3.40413 4.15753 3.40413H2.83217L2.88441 3.30401C3.11951 2.8861 3.46963 2.67594 3.97915 2.67594C4.36652 2.67594 4.55467 2.78825 4.86326 3.02653C5.00909 3.13916 5.21938 3.11279 5.33071 2.96598C5.44334 2.82015 5.41665 2.61084 5.27081 2.49854Z"
                            fill="#28AB69"
                          />
                        </svg>
                        <span className="text-sm">Cashback extracredit</span>
                        <span className="text-sm">
                          <b>
                            {currencyFormat[currencyProduct]} {formatPrice(cashback)}
                          </b>
                        </span>
                      </div>
                    )}

                    <Button
                      className="w-full border-none border-round-lg px-4 py-3 uppercase text-white font-semibold"
                      label={localeText("finishOrder")}
                      style={{ backgroundColor: "#28AB69" }}
                      onClick={async () => {
                        setLoading(true);
                        setIsLoadingToContinue(true);

                        const userInfo = await getUserInfoService.getUserInfo(
                          localStorage.getItem("__extraconomy_token"),
                          localStorage.getItem("__extraconomy_username")
                        );

                        if (userInfo.messageCode === 200001) {
                          const user = userInfo.result.user;
                          if (!user?.phoneNumber || !user?.internationalCode) {
                            history.push("/dashboard-editprofile");
                            showErrorToast({ detail: "errorDontHavePhoneNumber" });
                            setLoading(false);
                            setIsLoadingToContinue(false);
                            return;
                          }
                        } else {
                          showErrorToast({ code: userInfo.messageCode });
                          setLoading(false);
                          setIsLoadingToContinue(false);
                          return;
                        }

                        // If user doesn't have enough valid Extracredit credits (user percentage applied) and it's not their first 3 purchases as a Customer or Promoter plan
                        const resOrderCount = await userInfoService.getUserOrderCount(
                          localStorage.getItem("__extraconomy_token"),
                          localStorage.getItem("__extraconomy_username")
                        );

                        if (resOrderCount.messageCode !== 200001) {
                          showErrorToast({ code: 500000 });
                          setLoading(false);
                          setIsLoadingToContinue(false);
                          return;
                        }

                        if (
                          isFringeBenefitsPage
                            ? order.fringeBenefit.amountAvailable === 0
                            : order.itens.find(
                                (product) =>
                                  product.product.amountInStock === 0 &&
                                  !product.product.downloadable
                              )
                        ) {
                          showErrorToast({ code: 500074 });
                          setLoading(false);
                          setIsLoadingToContinue(false);
                          return false;
                        }
                        sendInitiateCheckout();
                        setPage(2);
                        setPrice(isFringeBenefitsPage ? order.totalOrder : order.amountTotal);
                      }}
                      loading={isLoadingToContinue || loading}
                      disabled={!localStorage.getItem(orderKey) || isLoadingToContinue || loading}
                    />
                  </div>
                </div>
              )}
            </div>
          )}

          {(!order || orderIsEmpty) && (
            <div
              className="flex flex-column card p-5 border-none border-round-lg mt-7 mx-auto text-center"
              style={{ boxShadow: "0px 0px 10px 0px rgba(0, 0, 0, 0.1)", maxWidth: "792px" }}
            >
              <div className="font-bold" style={{ color: "#344563" }}>
                {localeText("emptyCartText")}
              </div>
              <hr className="my-4"></hr>
              <div
                className="mb-6 mt-3 flex mx-auto text-sm"
                style={{ color: "#505F79", maxWidth: "375px" }}
              >
                {localeText("emptyCartSuggestion")}
              </div>
              <Link to={urlToCheckCatalog}>
                <button
                  className="cursor-pointer py-3 px-4 border-none border-round-lg font-medium"
                  style={{ backgroundColor: "#28AB69", color: "#FAFBFC" }}
                >
                  {localeText("checkCatalog")}
                </button>
              </Link>
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default CartItems;
